import React, { useEffect } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Action from "../Action/Action";

gsap.registerPlugin(ScrollTrigger);
ScrollTrigger.refresh();

const Shop = (props) => {
  const windowWidth = window.innerWidth;

  useEffect(() => {
    if (windowWidth >= 1024) {
      gsap.to(".bs-shop--product", {
        duration: 3,
        opacity: 1,
        translateX: "60px",
        scrollTrigger: {
          trigger: ".bs-shop",
          start: "-=500px"
          // markers: true,
        }
      });

      gsap.to(".bs-shop--text_content", {
        duration: 3,
        opacity: 1,
        translateX: "-10%",
        scrollTrigger: {
          trigger: ".bs-shop",
          start: "-=500px"
          // markers: true,
        }
      });
    } else {
      gsap.to(".bs-shop--product", {
        duration: 3,
        opacity: 1,
        marginLeft: 0,
        scrollTrigger: {
          trigger: ".bs-shop",
          start: "-=500px"
          // markers: true,
        }
      });

      gsap.to(".bs-shop--text_content", {
        duration: 3,
        opacity: 1,
        translateX: "0",
        scrollTrigger: {
          trigger: ".bs-shop",
          start: "-=500px"
          // markers: true,
        }
      });
    }
  }, [windowWidth]);

  return (
    <div
      id="shop"
      className="bs-shop"
      style={{
        display: "flex",
        flexDirection: "column"
      }}
    >
      <h2 className="bs-section--heading large" style={{ zIndex: "999" }}>
        Franchise <br />
        Sales Group
      </h2>

      <div className="bs-split" data-direction="left" style={{ width: "100%" }}>
        <div
          className="bs-split--poster"
          data-section="shop"
          data-direction="left"
        ></div>
        <div className="bs-split--text" data-direction="left">
          <h3
            className="bs-split--text_heading"
            style={{
              backgroundImage:
                "linear-gradient(-180deg, var(--bs-black), var(--bs-black))"
            }}
          >
            Franchise Sales Group
          </h3>
          <p className="bs-shop--contact">
            <span className="bs-shop--contact_label">Direct</span>: (909)
            237-8349
          </p>
          <p className="bs-shop--contact">
            <span className="bs-shop--contact_label">Email</span>:
            franchise@beignetspot.com
          </p>

          <Action
            href="https://beignetspotfranchise.com"
            label="Franchise With Us"
            type="shop"
          />
        </div>
      </div>
      <span className="bs-shop--sugar"></span>
    </div>
  );
};

export default Shop;
